module.exports = __webpack_public_path__ + "static/assets/535ad17a712455c69e96476f761a26a1.png";